import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
//import { getAuctioneerLotDetails, getDefaultAuthToken } from '../../Api';
import Moment from 'react-moment';
import DataTable from '../DataTable';
import Slider from "react-slick";
import ScrollContainer from 'react-indiana-drag-scroll'
import useApi from '../../api/useApi';
import ChatService from '../../services/ChatService';
import UsersService from '../../services/UsersService';
import { animated, useSpring, useTrail } from '@react-spring/web'
import useMeasure from 'react-use-measure'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { NumericFormat } from 'react-number-format';
import useAuth from '../../context/useAuth';
import coloredLotImage from '../../images/lot-colored2.png'
import specialLotImage from '../../images/lot-special.png'
import lotSkipImage from '../../images/lot-skip.png'
import suspectedLotImage from '../../images/lot-yellow.png'
import useLogout from '../../api/useLogout';

const LiveAuction = () => {
    const api = useApi();
    const navigate = useNavigate();
    const { auth } = useAuth();
    const [auctionStatus, setAuctionStatus] = useState(null);
    const [emptySpaceOccupiers, setEmptySpaceOccupiers] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36]);
    const [lock, setLock] = useState(true);
    const [confirmedPurchasesData, setConfirmedPurchasesData] = useState([]);
    const [confPurchaseModalVisible, setConfPurchaseModalVisible] = useState(false);
    const [lotSummary, setLotSummary] = useState({});
    const [lotList, setLotList] = useState([]);
    const lotListRef = React.useRef(lotList);
    const [stopMessage, setStopMessage] = useState(null);
    const stopMessageRef = React.useRef(stopMessage);

    const [lotDetail, setLotDetails] = useState({});
    const [currentBids, setCurrentBids] = useState([]);
    const [bid, setBid] = useState({});
    const bidRef = React.useRef(bid);

    const [incrementSeconds, setIncrementSeconds] = useState(2);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState({});
    const [selectedLot, setSelectedLot] = useState(null);
    const scrollContainerRef = useRef(null);
    const [auctionTime, setAuctionTime] = useState(0);
    const divRef = useRef(null);
    const logout = useLogout();


    useEffect(() => {
        bidRef.current = bid
        divRef.current.focus();
    }, [bid])

    const handleModalShow = (resetLot = false, autoHide = false) => {
        setModalVisible(true);

        if (autoHide) {
            setTimeout(() => {
                handleModalClose();
                if (resetLot)
                    setSelectedLot(null);
            }, 2000)
        }
    };

    const handleModalClose = () => {
        setModalVisible(false);
    };


    const handleOnConnectionEstablished = useRef(() => {
        getCurrentAuction();
    }).current;


    const handleOnMessageReceived = useRef((message) => {
        //console.log("Message Received ")
        //console.log(message)

        if (message) {
            switch (message.message) {
                case 'LIVE_AUCTION':
                    {
                        handleModalClose();
                        if (message.payload) {
                            setOnLoadAuctionData(message.payload);
                            //  setLock(false);
                            setStopMessage(null);
                            stopMessageRef.current = null;
                        }
                        break;
                    }
                case 'START_LOT':
                    {
                        handleModalClose();
                        setAuctionStatus('START_LOT');

                        if (message.payload) {
                            setOnLoadAuctionData(message.payload);
                            setLiveLotData(message.payload.currentLotDetail);
                            setBid(prevState => ({ ...prevState, currentBidAmount: message.payload.currentLotDetail.auctionStartPriceRs }));
                            setLock(false);
                            setStopMessage(null);
                            stopMessageRef.current = null;
                        }
                        break;
                    }
                case 'PLACE_BID':
                    {
                        if (message.senderId !== auth.userId) {
                            setLock(false);
                            console.log("stopMessageRef.current ")
                            console.log(stopMessageRef.current)
                            if (stopMessageRef.current != null && stopMessageRef.current !== undefined && stopMessageRef.current.indexOf("Dealer") === -1) {
                                setStopMessage(null);
                                stopMessageRef.current = null;
                            }
                        }

                        setAuctionStatus('PLACE_BID')
                        if (message.payload) {
                            setCurrentBids(previousBids => [...previousBids, {
                                lotId: message.lotId,
                                lotNo: message.lotNumber,
                                bidNo: message.bidNo,
                                bidAmount: message.bidAmount
                            }]);
                            setBid(prevState => ({
                                ...prevState,
                                lotId: message.lotId,
                                lotNo: message.lotNumber,
                                yourBidAmount: (message.senderId === auth.userId ? message.yourBidAmount : prevState.yourBidAmount),
                                currentBidAmount: message.bidAmount,
                                currentBidNumber: message.bidNo
                            }));
                        }
                        break;
                    }
                case 'LOT_SOLD':
                    {
                        setAuctionStatus('LOT_SOLD');

                        if (message.lotId === bidRef.current.lotId && message.bidAmount === bidRef.current.yourBidAmount) {
                            setModalMessage({
                                lotNo: message.payload.lotNumber,
                                bidAmount: message.payload.bidAmount,
                                type: 'success',
                                message: 'Congratulations! You won the lot.'
                            });
                            handleModalShow(true, true);
                            setCurrentBids([]);
                            // getCurrentAuction();
                        }
                        else if (message.bidAmount !== bidRef.current.yourBidAmount) {
                            setModalMessage({
                                lotNo: message.payload.lotNumber,
                                bidAmount: message.payload.bidAmount,
                                type: 'error',
                                message: 'Sorry! Better luck next time.'
                            });
                            handleModalShow(true, true);
                            setCurrentBids([]);
                            //getCurrentAuction();
                        }
                        break;
                    }
                case 'LOT_WITHDRAWN':
                    {
                        setAuctionStatus('LOT_WITHDRAWN')
                        setModalMessage({
                            lotNo: message.payload.lotNumber,
                            bidAmount: message.payload.bidAmount,
                            type: 'error',
                            message: 'Sorry! Lot has been withdrawn.'
                        });
                        handleModalShow(true, true);
                        //getCurrentAuction();
                        setCurrentBids([]);
                        break;
                    }
                case 'LOT_RERUN':
                    {
                        setAuctionStatus('LOT_RERUN')
                        setModalMessage({
                            lotNo: message.payload.lotNumber,
                            bidAmount: message.payload.bidAmount,
                            type: 'error',
                            message: 'Heads Up! Lot is being re-run.'
                        });
                        handleModalShow(false, true);
                        setCurrentBids([]);
                        // getCurrentAuction();
                        break;
                    }
                case 'AUCTION_CLOSED':
                    {
                        setModalMessage({
                            lotNo: 0,
                            type: 'error',
                            message: 'AUCTION CLOSED - logging out...'
                        });
                        handleModalShow(true, true);
                        setTimeout(() => {
                            logout();
                            //navigate('/trader')
                        }, 3000)

                        break;
                    }
                default:
            }
        }
    }).current;

    const handleOnTimerTick = useRef((seconds) => {
        setAuctionTime(seconds);
        //if (seconds === 0)
        //    handleModalShow(true);
    }).current;

    const handleOnTimerTimeout = useRef((lotId) => {

        const currentLot = lotListRef.current.find(t => t.lotId === lotId);
        setModalMessage({
            lotNo: currentLot.lotNo,
            type: 'primary',
            message: 'Bidding has been closed for the Lot.'
        });
        stopMessageRef.current = null;
        setStopMessage(null);
        handleModalShow(false, true);

        //setTimeout(() => {
        //    handleModalClose();
        //}, 3000);

    }).current;


    const _chatService = ChatService({ onConnectionEstablished: handleOnConnectionEstablished, messageReceived: handleOnMessageReceived, timerTick: handleOnTimerTick, timerTimeout: handleOnTimerTimeout });


    const bagRenderer = (props) => {
        let bag;
        const indicator = [1, 2, 3, 4, 5].find(t => t === props.status) ? <span className="current-bag"></span> : null;
        if (props.isSpecialLot && props.status === 7) { //special lot skip
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-skip">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isSpecialLot && props.status === 6) { //special lot withdrawn
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-withdrawn">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        } else if (props.isSpecialLot && props.status === 8) { //special lot sold
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-sold">
                <span>{props.lotNumber}</span>
                <small className="sold-price"> <small className="tx-6"> ₹</small>{props.finalPrice}</small>
            </span>
        }
        else if (props.isSpecialLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isColoredLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-colored">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isSuspectedLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-suspected">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.status === 6) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-withdrawn">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        } else if (props.status === 7) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-skip">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.status === 8) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-sold">
                <span>{props.lotNumber}</span>
                <small className="sold-price"> <small className="tx-6"> ₹</small>{props.finalPrice}</small>
            </span>
        }
        else {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-green">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        return bag;
    }


    const handleScroll = () => {

        const container = scrollContainerRef.current.container.current;
        const scrollPosition = scrollContainerRef.current.container.current.scrollLeft
        //console.log(scrollPosition)

        const activeBagContainer = document.getElementById('active-bag-container')
        const activeContainerStart = activeBagContainer.getBoundingClientRect().left;
        const activeContainerWidth = activeBagContainer.getBoundingClientRect().width;
        const activeContainerEnd = activeContainerStart + activeContainerWidth;

        const firstVisibleLot = lotListRef.current.find((lot, index) => {
            const lotElement = document.getElementById(`lot-${lot.lotId}`);
            if (lotElement) {
                const { left, right } = lotElement.getBoundingClientRect();

                return left >= activeContainerStart && right <= activeContainerEnd;
            }
            return false;
        });
        setSelectedLot(firstVisibleLot)
        //// Do something with the firstVisibleLot
        //console.log('First visible lot:', firstVisibleLot);
    };

    const scrollToLot = async (lotId) => {

        //console.log("scroll initiated ");
        const container = scrollContainerRef.current.container.current;
        const lotIndex = lotListRef.current.findIndex(t => t.lotId === lotId);
        const lotElement = document.getElementById(`lot-${lotId}`);
        //console.log("lotIndex " + lotIndex)
        //console.log("(lotIndex*60) " + (lotIndex * 60))
        if (lotElement) {
            //console.log("2");
            container.scrollTo({
                left: (lotIndex * 60), // Adjust based on your use case (e.g., left or top)
                behavior: 'smooth', // You can use 'auto' or 'smooth' for the scrolling behavior
            });
        }
    }

    const handleOnScrollEnd = () => {
        const container = scrollContainerRef.current.container.current;
        const scrollPosition = scrollContainerRef.current.container.current.scrollLeft;
        const nearestMultiple = Math.round(scrollPosition / 60) * 60;

        if (scrollPosition % 60 !== 0) {
            container.scrollTo({
                left: nearestMultiple, // Adjust based on your use case (e.g., left or top)
                behavior: 'smooth', // You can use 'auto' or 'smooth' for the scrolling behavior
            });
        }
    }

    const getCurrentAuction = async () => {
        try {
            const _msg = {
                message: "LIVE_AUCTION"
            }
            _chatService.sendMessage(_msg);

        } catch (error) {
            alert('Unable to get current auction.');
        }
    };

    //const getLotDetail = async () => {
    //    try {
    //        const _msg = {
    //            message: "LIVE_AUCTION_LOT_DETAIL"
    //        }
    //        _chatService.sendMessage(_msg);

    //    } catch (error) {
    //        alert('Unable to get current auction.');
    //    }
    //};

    const setOnLoadAuctionData = (initialAuctionData) => {
        try {
            if (initialAuctionData) {
                setLotSummary(initialAuctionData.lotSummary);
                setLotList(initialAuctionData.lotList);

                if (initialAuctionData.currentLotDetail !== null)
                    setLotDetails(initialAuctionData.currentLotDetail);

                lotListRef.current = initialAuctionData.lotList;

                if (initialAuctionData.currentBids !== null)
                    setCurrentBids(initialAuctionData.currentBids);

                const currentLot = initialAuctionData.lotList.find(t => t.status >= 3 && t.status <= 4);
                debugger
                if (currentLot) {
                    setSelectedLot(currentLot);
                    setTimeout(() => {
                        scrollToLot(parseInt(currentLot.lotId));
                    }, 100);
                    if (currentLot.status === 3)
                        setAuctionStatus('PLACE_BID')
                    else if (currentLot.status === 4) {
                        setAuctionStatus('TIME_UP')
                        setModalMessage({
                            lotNo: currentLot.lotNumber,
                            type: 'primary',
                            message: 'Bidding has been closed for the Lot.'
                        });
                        handleModalShow(false, true);
                    }
                }
            }
        } catch (error) {
            alert('Unable to fetch lot summary data.');
        }
    };

    const setLiveLotData = (liveLotDetail) => {
        try {
            if (liveLotDetail) {
                setLotDetails(liveLotDetail);
                setBid({ lotId: liveLotDetail.lotId, lotNo: liveLotDetail.lotNumber, auctionStartPrice: liveLotDetail.auctionStartPriceRs, increment: liveLotDetail.increment, currentBidAmount: undefined, currentBidNumber: 0 });
                let currentLot = lotListRef.current.find(t => t.lotId === liveLotDetail.lotId);
                currentLot.crnosblNo = liveLotDetail.crnosblNo;

                if (currentLot) {
                    setSelectedLot(currentLot);
                    setTimeout(() => {
                        scrollToLot(parseInt(currentLot.lotId));
                    }, 100);
                }
            }
        } catch (error) {
            alert('Unable to set live lot data.');
        }
    };

    const onPlaceBid = async (increment) => {
        if (!lock) {
            if (selectedLot && auctionTime > 0) {
                setLock(true);
                if (selectedLot.crnosblNo !== auth.licenseNo) {
                    let currentAmount = bid.currentBidAmount;
                    //UNCOMMENT BELOW IF CONDITION WHEN START PRICE IS REQUIRED AS THE 1ST BID PRICE.
                    //if (currentAmount === undefined || currentAmount === null)
                    //    currentAmount = bid.auctionStartPrice;
                    //else
                    //    currentAmount += parseFloat(bid.increment);


                    //COMMENT THESE 3 LINES IF ABOVE LINES ARE UNCOMMENTED
                    if (currentAmount === undefined || currentAmount === null)
                        currentAmount = bid.auctionStartPrice;

                    currentAmount += parseFloat(increment);


                    let currentNumber = bid.currentBidNumber;

                    if (currentNumber === undefined || currentNumber === null)
                        currentNumber = 0;

                    currentNumber += 1;


                    const _msg = {
                        lotId: selectedLot.lotId,
                        auctionId: selectedLot.auctionId,
                        bidNo: currentNumber,
                        increment: increment,
                        bidAmount: currentAmount,
                        message: "PLACE_BID"
                    }
                    _chatService.sendMessage(_msg);
                    //if (selectedLot && auctionTime > 0) { //DONT REMOVE THIS IF CONDITION check again : second time
                    //    setBid(prevState => ({ ...prevState, lotId: selectedLot.lotId, lotNo: selectedLot.lotNumber, yourBidAmount: currentAmount, currentBidAmount: currentAmount, currentBidNumber: currentNumber }));
                    //}
                } else {
                    setStopMessage("Bidding not allowed for this lot. Dealer's own lot detected.");
                    stopMessageRef.current = "Bidding not allowed for this lot. Dealer's own lot detected.";
                    setLock(false)
                }
            }
            else
                alert("Action not allowed");
        }
        else {
            setStopMessage("Sorry! Only 1 bid is allowed at a time. Please wait for others to bid.");
            stopMessageRef.current = "Sorry! Only 1 bid is allowed at a time. Please wait for others to bid.";
        }
    }


    const handleKeyDown = (event) => {

        const { key } = event;
        if ((key >= '3' && key <= '9') || key === 'Enter') {
            let increment = key === 'Enter' ? 2 : parseInt(key);
            if (auctionTime > 0 && !modalVisible)
                onPlaceBid(increment);
        }
    };

    const closePurchaseModal = () => {
        setConfPurchaseModalVisible(false);
    }

    const handleConfirmedPurcases = async () => {
        await api.getConfirmedPurchasesReport().then((data) => {
            setConfirmedPurchasesData(data);
        });
        setConfPurchaseModalVisible(true);
    }

    return (
        <div tabIndex={0} className="inner-body no-focus" ref={divRef} onKeyDown={handleKeyDown} >
            <div >
                <button className="btn btn-outline-primary btn-sm mg-t-10 tx-10" style={{ position: 'absolute', left: 4, borderColor: "#c1c1c1" }} onClick={() => navigate('/trader')}><i class="ti ti-arrow-left me-2"></i>Home</button>

                <div className="row row-sm mg-md-t-10 mg-b-5 mg-sm-t-70 ">
                    <div className="col-md-12">

                        <div className="card overflow-visible" >
                            <div className="pd-5  d-flex justify-content-around fs-13" style={{ backgroundColor: "#6259ca0d", borderBottomWidth: '1px', borderBottomStyle: "solid", borderBottomColor: '#dfdfdf' }}>
                                <div className="d-flex justify-content-around flex-fill rounded-top-11 rounded-start-0 align-items-center">
                                    <span className="mg-b-0">Total Lots  :  <strong>{lotSummary.totalLots}</strong></span>
                                </div>
                                <div className="d-flex justify-content-around flex-fill bd-r  align-items-center">
                                    <span className="mg-b-0">Lots Remaining  : <strong>{lotSummary.lotsRemaining}</strong></span>
                                </div>
                                <div className=" d-flex justify-content-around flex-fill rounded-top-11 rounded-end-0 bd-r align-items-center">
                                    <span className="mg-b-0">Lots Sold : <strong>{lotSummary.lotsSold}</strong> </span>
                                </div>
                                <div className="d-flex justify-content-around flex-fill bd-r  align-items-center">
                                    <span className="mg-b-0">Lots Withdrawn : <strong>{lotSummary.lotsWithdrawn}</strong></span>
                                </div>
                                <div className="d-flex justify-content-around flex-fill bd-r  align-items-center">
                                    <span className="mg-b-0">Total Auction Qty. : <strong> {lotSummary.totalQuantity}</strong> kg</span>
                                </div>

                            </div>
                            {selectedLot ?
                                <div id="active-bag-container" className="active-bag"></div> : null}
                            {lotListRef.current ?
                                <ScrollContainer
                                    className="scroll-container d-flex flex-row justify-content-start pd-8 pd-l-140 overflow-x-scroll scrollbar-hide"
                                    vertical={false}
                                    horizontal={false}
                                    ref={scrollContainerRef}
                                    onEndScroll={handleOnScrollEnd}
                                >

                                    {lotList.map((t, index) => {
                                        return <div key={index} className="lot-bag-container">
                                            {bagRenderer(t)}
                                        </div>
                                    })}
                                    {emptySpaceOccupiers.map((t, index) => {
                                        return <div key={index} className="lot-bag-container">

                                        </div>
                                    })}
                                </ScrollContainer> : <Skeleton containerClassName="flex-1" height={'100%'} />}
                        </div>
                    </div>
                </div>
                <div className="row row-xs ">
                    <div className="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                        <div className="card custom-card mg-b-6" style={{ minHeight: '337px', borderTopWidth: '5px', borderTopColor: "#3b3b6e", borderTopStyle: "solid" }}>

                            <div className="card-body pd-t-12 pd-b-10  fs-12">
                                {selectedLot ? <div className="row row-xs" style={{ fontSize: '1rem' }}>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 ">
                                        <table className="table mb-0 border-top table-bordered text-nowrap small-cell-padding highlight-dark  text-right">
                                            <tbody>
                                                <tr><td >Lot Size (Kg)</td>
                                                    <th className="text-end">{lotDetail?.quantityKg || "--"} Kg</th></tr>
                                                <tr><td >Liter-Weight</td>
                                                    <th className="text-end">{lotDetail?.litreWeightGms || "--"} Grams</th>
                                                </tr>
                                                <tr><td >Color</td>
                                                    <th className="text-end">--</th>
                                                </tr>
                                                <tr><td >Moisture (%)</td>
                                                    <th className="text-end">{lotDetail?.moistureContent || "--"}</th>
                                                </tr>
                                                <tr><td >No. of bags</td>
                                                    <th className="text-end">{lotDetail?.bags || "--"}</th>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                        <table className="table mb-0 border-top table-bordered text-nowrap small-cell-padding highlight-dark text-right">
                                            <tbody>
                                                <tr >
                                                    <td className="highlight-light">Seller</td>
                                                    <th className="text-end highlight-light-force">{lotDetail?.planterDealer === '1' ? 'Planter' : (lotDetail?.planterDealer === '2' ? 'Dealer' : lotDetail?.planterDealer) || "--"} </th></tr>
                                                <tr>
                                                    <td>Size</td>
                                                    <th className="text-end">{lotDetail?.size || "--"}</th></tr>
                                                <tr><td >Rejection</td>
                                                    <th className="text-end">{lotDetail?.rejection || "--"}</th>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="bd d-none d-xl-block d-xxl-block   justify-content-center align-items-center ht-100 mg-t-10 tx-gray-500">
                                        <span>Image not available</span>
                                    </div>
                                </div> : awaitLotPlaceholder}

                                <div className="mg-t-10">
                                    <span>Auction Number / Auctioneer :</span>
                                    <h6 className="mg-0">{lotSummary?.auctionNo || "--"} / {lotSummary?.companyName || "--"} </h6>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-sm-12 col-md-7 col-lg-7 col-xl-7">
                        <div className="card custom-card  mg-b-6" style={{ minHeight: '337px', }}>
                            <div className="card-header border-bottom-0 pd-t-6 d-flex justify-content-between">
                            </div>{selectedLot ?
                                <div className="card-body pd-8 ">
                                    <div className="row row-xs">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="bd" style={{ height: '316px', borderRadius: '2px' }}>
                                                <div className="card-header border-bottom-0 pd-l-0 pd-t-0 text-center">
                                                    <label className="main-content-label my-auto pt-2 pd-b-10">Lot Biddings </label>
                                                </div>
                                                <div style={{ maxHeight: '244px', overflowY: "auto" }}>
                                                    {currentBids.length > 0 ?
                                                        currentBids.slice().reverse().map((t, index) => {
                                                            return <div key={index} className="custom-list-card2 rounded-0">
                                                                <span>Bid {t.bidNo}</span>
                                                                <span>₹ {t.bidAmount}</span>
                                                            </div>

                                                        }) : <div className="custom-list-card2 no-bidding rounded-0">
                                                            <span>-- No bidding(s) --</span>
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="custom-list-card2 rounded d-block text-center justify-content-center align-items-center">
                                                <span className="d-flex align-items-center">Lot No <strong className="me-1 ms-1"> <h2>{lotDetail.lotNumber}</h2> </strong> started at base price : </span>
                                                <div className="d-flex justify-content-center">
                                                    <small className="tx-14 mg-l-3 mg-r-2 mg-t-2 text-muted">₹ </small>
                                                    <h2 className="mg-0">{lotDetail.auctionStartPriceRs}</h2>
                                                </div>


                                            </div>
                                            <div className="custom-list-card2 rounded d-block text-center " style={{ paddingRight: '4px' }}>
                                                {/*<div className="row row-xs text-center">*/}
                                                <div className="wd-40p custom-bd-r">
                                                    <span className="tx-11">Your Bid</span>
                                                    <div className="d-flex justify-content-center">
                                                        <small className="tx-14 mg-t-3 text-muted">₹ </small>
                                                        <h1>{bid.yourBidAmount || "--"}</h1>
                                                    </div>

                                                </div>
                                                <div className={auctionTime > 0 && bid.yourBidAmount > 0 && bid.yourBidAmount === bid.currentBidAmount ? "wd-40p custom-bd-r high-bid" : auctionTime > 0 && bid.yourBidAmount < bid.currentBidAmount ? "wd-40p custom-bd-r low-bid" : "wd-40p custom-bd-r "}>
                                                    <span className="tx-11">Current Bid</span>
                                                    <div className="d-flex justify-content-center">
                                                        <small className="tx-14 mg-t-3 text-muted">₹ </small>
                                                        <h1 className="inline"> {bid.currentBidAmount || "--"}</h1>
                                                    </div>
                                                </div>
                                                <div className="wd-70 d-flex justify-content-center align-items-center bid-increment">
                                                    <h2 className="mg-0">+{incrementSeconds}</h2>
                                                </div>
                                                {/*</div>*/}

                                            </div>
                                            <div className="custom-list-card2 rounded d-block flex-column">
                                                <div className="d-flex">
                                                    <div className="col-8 text-end">
                                                        <div className="mg-0 display-4">{auctionTime} </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="tx-11 mg-t-7">seconds</div>
                                                        <div className="tx-11">remaining</div>
                                                    </div>
                                                </div>
                                                {auctionTime > 0 && bid.yourBidAmount !== undefined && bid.yourBidAmount === bid.currentBidAmount ?
                                                    <div className="row row-xs text-center text-success">
                                                        <h6>You are the highest bidder.</h6>
                                                    </div> : auctionTime > 0 && bid.yourBidAmount !== undefined && bid.yourBidAmount < bid.currentBidAmount ?
                                                        <div className="row row-xs text-center text-danger">
                                                            <h6>Bid higher to win this lot.</h6>
                                                        </div> : auctionTime > 0 ? <div className="row row-xs text-center">
                                                            <h6>Place your bid to win this lot.</h6>
                                                        </div> : null}


                                                {stopMessage ? <div className="row row-xs text-center text-danger">
                                                    <h6>{stopMessage}</h6>
                                                </div> : null}

                                            </div>

                                        </div>
                                    </div>
                                </div> : awaitLotPlaceholder}
                        </div>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card overflow-hidden">
                            <div className="d-flex justify-content-around pd-t-10 pd-b-5">
                                <div className="pe-0 ps-0 ">
                                    <div className="card-body text-center pd-4">
                                        <h6 className="mb-0">Auction Min</h6>
                                        <div className="d-flex">
                                            <span className="counter">₹</span>
                                            <h4 className="mb-1  number-font">{lotSummary?.auctionMin?.toFixed(2)}</h4>
                                        </div>
                                        {/*{!lotSummary.auctionMin && <Skeleton />}*/}
                                        {/*{lotSummary.auctionMin !== undefined ? <div className="d-flex">*/}
                                        {/*    <span className="counter">₹</span>*/}
                                        {/*    <h4 className="mb-1  number-font">{lotSummary?.auctionMin?.toFixed(2)}</h4>*/}
                                        {/*</div> : null}*/}
                                    </div>
                                </div>
                                <div className="pe-0 ps-0 ">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Auction Max</h6>
                                        <div className="d-flex">
                                            <span className="counter">₹</span>
                                            <h4 className="mb-1  number-font">{lotSummary?.auctionMax?.toFixed(2)}</h4>
                                        </div>
                                        {/*{!lotSummary.auctionMax && <Skeleton />}*/}
                                        {/*{lotSummary.auctionMax !== undefined ? <div className="d-flex">*/}
                                        {/*    <span className="counter">₹</span>*/}
                                        {/*    <h4 className="mb-1  number-font">{lotSummary?.auctionMax?.toFixed(2)}</h4>*/}
                                        {/*</div> : null}*/}


                                    </div>
                                </div>
                                <div className="pe-0 ps-0 ">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Auction Avg</h6>
                                        <div className="d-flex">
                                            <span className="counter">₹</span>
                                            <h4 className="mb-1  number-font">{lotSummary?.auctionAvg?.toFixed(2)}</h4>
                                        </div>
                                        {/*{!lotSummary.auctionAvg && <Skeleton />}*/}
                                        {/*{lotSummary.auctionAvg !== undefined ? <div className="d-flex">*/}
                                        {/*    <span className="counter">₹</span>*/}
                                        {/*    <h4 className="mb-1  number-font">{lotSummary?.auctionAvg?.toFixed(2)}</h4>*/}
                                        {/*</div> : null}*/}
                                    </div>
                                </div>

                                <div className="pe-0 ps-0">
                                    <div className="card-body text-center  pd-4">
                                        <button className="btn btn-outline-primary btn-sm mg-t-10" onClick={handleConfirmedPurcases}>View your confirmed purchases</button>
                                    </div>
                                </div>

                            </div>
                            {/*{trail.map((styles, index) => (*/}
                            {/*    <animated.div key={index} style={{ ...styles, position: index === 1 ? 'absolute' : 'relative', backgroundColor: index === 1 ? 'red' : 'blue' }}>*/}
                            {/*        {items[index]}*/}
                            {/*    </animated.div>*/}
                            {/*))}*/}
                        </div>
                    </div>
                </div>

                <Modal show={modalVisible} centered>
                    <Modal.Header className="modal-header pd-12">
                        <Modal.Title>Timeup</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="text-center">
                            <h2>Lot No. {modalMessage.lotNo} </h2>
                            {modalMessage.bidAmount ? <div className="d-flex justify-content-center">
                                <h4 className="mg-t-4">Bidding closed at  </h4>  <span className="counter mg-l-8 mg-t-4">₹</span><h4 className="mg-t-5">{modalMessage.bidAmount}</h4>
                            </div> : null}
                            <h3 className={modalMessage.type === "success" ? "tx-success" : (modalMessage.type === "error" ? "tx-danger" : "tx-primary")}>{modalMessage.message}</h3>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

            <Modal show={confPurchaseModalVisible} size='lg' onHide={closePurchaseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Your Confirmed Purchases</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pd-t-0">
                    <div className="d-flex text-center bg-primary pd-t-5 mg-b-4">
                        <div className="col-4">
                            <small> Bags (Total Quanity)</small>
                            <h5>{Sum(confirmedPurchasesData, 'bags')} (<NumericFormat suffix={' Kg '} displayType="text" value={Sum(confirmedPurchasesData, 'quantityKg')} allowLeadingZeros thousandSeparator="," decimalScale={2} />)</h5>
                        </div>
                        <div className="col-4">
                            <small>  Total Value</small>
                            <h5><NumericFormat prefix={'₹ '} displayType="text" value={Sum(confirmedPurchasesData, 'lotValue')} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </h5>
                        </div>
                        <div className="col-4">
                            <small>  Average</small>
                            <h5> <NumericFormat prefix={'₹ '} displayType="text" value={Average(confirmedPurchasesData, 'price')} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h5>
                        </div>
                    </div>
                    <div className="table-responsive border border-bottom-0">
                        <table className="table table-hover table-bordered table-striped  table-vcenter mb-0 tx-12">
                            <thead>
                                <tr>
                                    {/*<th className="text-center tx-12">#</th>*/}
                                    <th className="text-center tx-12">Lot No</th>
                                    <th className="text-center tx-12">Color</th>
                                    <th className="text-center tx-12">Liter Weight (Moisture)</th>
                                    <th className="text-center tx-12">No. of bags</th>
                                    <th className="text-center tx-12">Grower</th>
                                    <th className="text-center tx-12">Lot Size</th>
                                    <th className="text-center tx-12">Lot Price</th>
                                    <th className="text-center tx-12">Lot Value</th>
                                </tr>
                            </thead>
                            <tbody className="custom-hover-table  text-nowrap fixed-hight-400">
                                {confirmedPurchasesData.map((pur, index) => {
                                    return <tr>
                                        {/*<td className="text-center">{index + 1}</td>*/}
                                        <td className="text-center">{pur.lotNumber} </td>
                                        <td className="text-center">{pur.colored} </td>
                                        <td className="text-center">{pur.litreWeightGms} ({pur.moistureContent} %) </td>
                                        <td className="text-center">{pur.bags} </td>
                                        <td className="text-center">{pur.grower} </td>
                                        <td className="text-center">{pur.quantityKg} Kg</td>
                                        <td className="text-center">₹ {pur.price} </td>
                                        <td className="text-center">₹ {pur.lotValue} </td>
                                    </tr>
                                })}
                                {confirmedPurchasesData?.length === 0 ? <tr>
                                    <td colSpan="9" className="text-center">No records available.</td>
                                </tr> : null}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default LiveAuction;


const tableSkeleton = () => {
    return <div style={{ width: '100%' }}>
        <Skeleton containerClassName="flex-1" height={22} count={5} style={{ marginBottom: "2px" }} />
    </div>
}

const awaitLotPlaceholder = (
    <div className="d-flex flex-column pd-60">
        <h3 className="tx-gray-700">Awaiting lot start...</h3>
        <Skeleton containerClassName="flex-1" height={22} count={2} style={{ marginBottom: "2px" }} />
    </div>)

function Sum(arr, prop) {
    return arr.reduce((accumulator, currentObject) => {
        return accumulator + currentObject[prop];
    }, 0);
}

function Average(arr, prop) {
    const sum = arr.reduce((accumulator, currentObject) => {
        return accumulator + currentObject[prop];
    }, 0);

    return arr.length > 0 ? sum / arr.length : 0;
}
